import {Injectable} from '@angular/core';
import {Amplify} from '@aws-amplify/core';
import {cognitoCredentialsProvider, cognitoUserPoolsTokenProvider,} from '@aws-amplify/auth/cognito';
import {AppConfig} from '@api/utisha-app-config';
import {AppConfigHolder} from '../services/app-config-holder';
import {logUtishaDebug} from '../util/log';

const IS_LOCALHOST = location.hostname.indexOf('localhost') >= 0;

@Injectable({
  providedIn: 'root'
})
export class AwsInitializer {

  constructor(private appConfigHolder: AppConfigHolder) {
  }

  configureAmplify(config: AppConfig): void {

    // https://github.com/aws-amplify/docs/issues/3705
    const amplifyConfig = {
      // OPTIONAL - if your API requires authentication
      Auth: {
        Cognito: {
          // REQUIRED - Amazon Cognito Identity Pool ID
          identityPoolId: config.identityPoolId,
          // OPTIONAL - Amazon Cognito User Pool ID
          userPoolId:  config.cognitoUserPool,
          // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
          userPoolClientId: config.userPoolWebClientId,
          // see @aws-amplify\auth\src\types\Auth.ts
          authenticationFlowType: 'USER_SRP_AUTH', // Default for username/password
          loginWith: {
            oauth: {
              providers: ['Google', 'Microsoft'],
              domain: config.oauthServer!,
              scopes: ['email', 'openid', 'profile'],
              redirectSignIn: [`${location.origin}/token`],
              redirectSignOut: [location.origin],
              responseType: 'code',
            },
            email: true
          },
        }
      }
    };
    logUtishaDebug(JSON.stringify(amplifyConfig, null, 6));
    // Wire up the Cognito token + credentials providers explicitly.
    // The umbrella `aws-amplify` package does this automatically inside its
    // overridden Amplify.configure(); since we're importing Amplify from
    // @aws-amplify/core directly, we have to replicate that wiring here,
    // otherwise @aws-amplify/auth will throw "Auth UserPool not configured."
    // @ts-ignore - AppConfig fields are string|undefined but the runtime always populates them
    cognitoUserPoolsTokenProvider.setAuthConfig(amplifyConfig.Auth);
    // @ts-ignore - amplifyConfig shape matches ResourcesConfig at runtime
    Amplify.configure(amplifyConfig, {
      Auth: {
        tokenProvider: cognitoUserPoolsTokenProvider,
        credentialsProvider: cognitoCredentialsProvider,
      },
    });
  }

  private get secondLevelDomain() {
    const parts = location.hostname.split('.');
    return parts.slice(-2).join('.');
  }
}
